module.exports = __webpack_public_path__ + "img/germany.7bb96171.svg";